
import C002TiposDependencias from '../../../src/components/REGOP/Catalogos/C002TiposDependencias.vue'
import C003TiposEnvio from '../../../src/components/REGOP/Catalogos/C003TiposEnvio.vue'

const regop = [
	{ Proviene: 'REGOP', Nombre: 'C002TiposDependencias', datos: C002TiposDependencias },
	{ Proviene: 'REGOP', Nombre: 'C003TiposEnvio', datos: C003TiposEnvio },
]

export default regop;


//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/regop.js
// module id = null
// module chunks = 